import { render, staticRenderFns } from "./FormPago.vue?vue&type=template&id=f1fb58cc&scoped=true&"
import script from "./FormPago.vue?vue&type=script&lang=ts&"
export * from "./FormPago.vue?vue&type=script&lang=ts&"
import style0 from "./FormPago.vue?vue&type=style&index=0&id=f1fb58cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fb58cc",
  null
  
)

export default component.exports